import Footer from "./footer.component";

export default Footer;
